import getEnvVar from './getEnvVar';

type EnvironmentType = 'dev' | 'qa' | 'perf' | 'stg' | 'prod';

export const getRuntimeEnvironment = () => {
  const nodeEnv = getEnvVar('REACT_APP_NODE_ENV', 'dev');
  return nodeEnv as EnvironmentType;
};
